import { get } from 'lodash'
import React from 'react'
import ReactDOM from 'react-dom'

const AdvanceSearchPortal = ({ children, withPortal = true }) => {
  if (!withPortal) {
    return children
  }
  let foundDiv = document.getElementById('AdvancedSearchV2PortalContainer')

  let div: any

  if (foundDiv) {
    div = foundDiv
  } else {
    div = document.createElement('div')
    div.setAttribute('id', 'AdvancedSearchV2PortalContainer')

    const getTrialDOM = document.querySelector('.cs-trial-flag')
    getTrialDOM && div.setAttribute('class', 'trial-active')
    document.body.appendChild(div)
  }

  // function resetAdvSearch() {
  //   if (div.parentNode) {
  //     div.parentNode.removeChild(div)
  //     // onCloseAdvancedSearch && onCloseAdvancedSearch()
  //   }
  // }

  return ReactDOM.createPortal(children, div)
}

export default AdvanceSearchPortal
